/* @fflow */
import React, { Component } from 'react';
// $FlowIgnore
import { GraphiQL } from 'graphiql';

import { gql } from '../utils/ajax';

class GraphiqlHandler extends Component {
  constructor() {
    super();
    require('graphiql/graphiql.css');
  }

  graphQLFetcher(graphQLParams: Object): Promise {
    return gql(graphQLParams);
  }

  render(): React.Element {
    return (
      <div style={{
        height: '94vh',
        flexGrow: 1
      }}>
        <GraphiQL fetcher={this.graphQLFetcher.bind(this)} />
      </div>
    );
  }
}

export default GraphiqlHandler;
